import { Blob } from "./blob.js";
import { Box, Container, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { getMinMaxPlayers } from "../utils.js";
import { ModalGenderRoles } from "./modal-gender-roles.js";
import { PlayersTable } from "./players-table.js";
import { ProductContext } from "../provider.js";
import { useTranslation } from "next-i18next";
import { QuestionMarkIcon } from "../../icons.js";
import { WOB_Age, WOB_Contents, WOB_DigitalContents, WOB_Duration, WOB_EAN, WOB_Players, } from "./icons.js";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import NiceModal from "@ebay/nice-modal-react";
import React from "react";
export const HorizontalLayout = () => {
    const { t } = useTranslation("c-product");
    const theme = useTheme();
    const product = React.useContext(ProductContext);
    const { colors, duration, ean } = product;
    const { minPlayers, maxPlayers } = getMinMaxPlayers(product);
    const showRolesGenderExplainer = () => NiceModal.show(ModalGenderRoles, { product });
    const BACKGROUND_COLOR = colors.secondary;
    const BORDER_STYLE = {
        position: "relative",
        "::after": {
            background: theme.palette.text.primary,
            bottom: 0,
            content: "''",
            height: "87%",
            position: "absolute",
            right: 0,
            width: "1px",
        },
    };
    return (React.createElement(Box, { component: "section", sx: {
            background: BACKGROUND_COLOR,
            boxShadow: "sectionVertical",
            pb: 18,
            position: "relative",
            pt: 13,
            zIndex: 25,
        } },
        React.createElement(Container, { component: "section", maxWidth: "xl" },
            React.createElement(Grid, { container: true, columnSpacing: { xs: 12, lg: 20 } },
                React.createElement(Grid, { xs: 4, sx: BORDER_STYLE },
                    React.createElement(Stack, { direction: "column", spacing: 9 },
                        React.createElement(Blob, { icon: React.createElement(WOB_Duration, null), title: t("duration", "Dauer"), subtitle: t("duration-copy-1", "{{min}} – {{max}} Stunden", {
                                min: duration.min,
                                max: duration.max,
                            }) }),
                        React.createElement(Blob, { icon: React.createElement(WOB_Age, null), title: t("age", "Alter"), subtitle: t("age-recommendation", "Geeignet ab 16 Jahren") }),
                        product.edition === "print" && React.createElement(Blob, { icon: React.createElement(WOB_EAN, null), title: "EAN", subtitle: ean }))),
                React.createElement(Grid, { xs: 4, sx: BORDER_STYLE },
                    React.createElement(Blob, { icon: product.edition === "online" ? React.createElement(WOB_DigitalContents, null) : React.createElement(WOB_Contents, null), title: t("contents", "Spielinhalt"), subtitle: t("contents-subheadline", "Spielinhalt") }),
                    product.edition === "online" && (React.createElement(React.Fragment, null,
                        React.createElement(Typography, { variant: "body1", sx: { pt: { xs: 2, lg: 3 } }, paragraph: true }, t("contents-online-copy-1", "Du erhältst alles, um dein Krimidinner sofort zu starten. Spiele direkt mit deinen Freunden am Tisch oder per Videokonferenz via Skype oder Zoom.")),
                        React.createElement(Typography, { variant: "body1" }, t("contents-online-copy-2", "Du brauchst keine Materialien auszudrucken oder zu kopieren. Es ist keine App-Installation nötig.")))),
                    product.edition === "print" && (React.createElement(React.Fragment, null,
                        React.createElement(Typography, { sx: { pt: { xs: 2, lg: 3 }, pb: { xs: 3, lg: 4 } } }, t("contents-print-copy-1", "Du erhältst alles, was du für dein eigenes Krimidinner für Zuhause brauchst:")),
                        React.createElement("ul", { style: { margin: 0, padding: 0, listStyle: "none" } },
                            React.createElement("li", null, t("1-game-manual", "1 × Spielanleitung")),
                            React.createElement("li", null, t("1-incident-booklet", "1 × Ereignisheft")),
                            React.createElement("li", null, t("x-game-booklets", "{{maxPlayers}} × Spielhefte", { maxPlayers })),
                            React.createElement("li", null, t("x-name-cards", "{{maxPlayers}} × Namensschilder", { maxPlayers })),
                            React.createElement("li", null, t("1-access-code", "1 × Support-Code"))),
                        React.createElement(Typography, { sx: { pt: 3 } }, t("contents-print-copy-2", "Du brauchst keine weiteren Materialien auszudrucken oder zu kopieren."))))),
                React.createElement(Grid, { xs: 4 },
                    React.createElement(Blob, { icon: React.createElement(WOB_Players, null), title: t("players", "Spieler"), subtitle: t("players-copy-1", "{{minPlayers}} – {{maxPlayers}} Personen", {
                            minPlayers,
                            maxPlayers,
                        }) }),
                    product.edition === "print" && (React.createElement(Typography, { sx: { pt: { xs: 2, lg: 3 } } }, t("gender-distribution-subheadline", "Verteilung der Rollen nach Geschlechtern:"))),
                    React.createElement(PlayersTable, { product: product }),
                    React.createElement(Typography, { component: "span" },
                        t("gender-switch-notice", "Männer-Rollen können von Frauen gespielt werden und umgekehrt."),
                        React.createElement(IconButton, { size: "small", onClick: showRolesGenderExplainer },
                            React.createElement(QuestionMarkIcon, { sx: { color: "inherit", fontSize: { xs: "20px", sm: "22px", md: "24px", lg: "30px" } } }))))))));
};
//# sourceMappingURL=horizontal-layout.js.map